import gql from 'graphql-tag'

export const GET_BARCODE_PRODUCT_LIST = gql`
  query GetBarcodeProducts {
    barcodeProductCategories {
      id
      name
    }
    options: __type(name: "BarcodeProductStatus") {
      status: enumValues {
        name
      }
    }
    presetGroups(orderBy: order_ASC) {
      id
      name
    }
  }
`

export const GET_BARCODE_PRODUCT_BY_ID = gql`
  query GetBarcodeProductById($id: Int!) {
    barcodeProduct(id: $id) {
      id
      category {
        id
        name
      }
      presetGroups {
        id
        name
      }
      barcodeData
      name
      brand
      cover {
        id
        name
        url
      }
      materials {
        id
        name
      }
      steps {
        id
        name
      }
      status
      presetMaterials {
        id
        material {
          id
          name
          images {
            id
            url
          }
        }
        desc
        extracting
      }
    }
    steps {
      id
      stepType {
        id
        name
      }
      name
      needTool
    }
    categories {
      id
      name
      description
      remark
      materials {
        id
        name
        cover {
          id
          url
        }
        images {
          id
          url
        }
      }
    }
  }
`
